import { createFeatureSelector, createSelector } from '@ngrx/store';

import { getCurrentOrganizationId$ } from './session.selector';
import { SEARCH_REDUCER_KEY } from '../reducers/search.reducer';
import { SearchState } from '../states/search.state';

const currentState = createFeatureSelector<SearchState>(SEARCH_REDUCER_KEY);

export const getAppSearchOrganizationMap$ = createSelector(
    currentState,
    getCurrentOrganizationId$,
    (state, organizationId) => state.organizations?.[organizationId]
);

const getAppSearchFiltersMap$ = (serviceId: string) => createSelector(getAppSearchOrganizationMap$, orgMap => orgMap?.[serviceId]);

export const getSearchDefaultFilters$ = (serviceId: string) =>
    createSelector(getAppSearchFiltersMap$(serviceId), servicesMap => servicesMap?.defaultFilters);

export const getSearchAppFilters$ = (serviceId: string) =>
    createSelector(getAppSearchFiltersMap$(serviceId), servicesMap => servicesMap?.searchFilters);

export const getSearchCriteriaMap$ = createSelector(currentState, state => state.searchCriteria);

export const getSearchCriteriaByServiceId$ = (serviceId: string) => createSelector(getSearchCriteriaMap$, map => map?.[serviceId]);

export const getSearchInstancesCriteria$ = (serviceId: string, criteriaName: string) =>
    createSelector(getSearchCriteriaByServiceId$(serviceId), map => map?.instances?.[criteriaName]);

export const getSearchRequestsCriteria$ = (serviceId: string, criteriaName: string) =>
    createSelector(getSearchCriteriaByServiceId$(serviceId), map => map?.requests?.[criteriaName]);

export const getSearchRecordsCriteria$ = (serviceId: string, criteriaName: string) =>
    createSelector(getSearchCriteriaByServiceId$(serviceId), map => map?.entities?.[criteriaName]);
